<template>
  <section class="section__hero">
    <div class="custom-container d-flex flex-wrap">
      <div class="hero">
        <div class="hero__item">
          <h1 class="hero__title">
            Charter<br class="d-inline d-lg-none"> Aviation<br class="d-none d-lg-inline">
            API <br class="d-inline d-lg-none">Solutions
          </h1>
          <h2 class="hero__subtitle">
            Calculate flight time, quote charter, search<br class="d-none d-lg-inline">
            aircraft, airports, operators and much more
          </h2>
          <div class="hero__buttons">
            <router-link to="/contacts" class="btn">Get Started For Free</router-link>
            <a href="/about" class="btn outlined explore_api_btn">Explore API</a>
          </div>
        </div>
      </div>

      <div class="map">
        <div class="map__wrapper">
          <div class="map__background">
<!--            <img class="map__image" src="../assets/map.webp" alt="map image">-->
            <div class="map__image__background"></div>
            <div class="aircraft">
              <img src="../assets/images/aircraft/aircraft_1.webp" class="aircraft__image_1" alt="aircraft_image">
              <img src="../assets/images/aircraft/aircraft_2.webp" class="aircraft__image_2" alt="aircraft_image">
              <img src="../assets/images/aircraft/aircraft_3.webp" class="aircraft__image_3" alt="aircraft_image">
            </div>
          </div>
        </div>

        <div class="background_mobile d-lg-none">
<!--          <svg width="600" height="217" viewBox="0 0 600 217" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path-->
<!--                d="M397.328 27.2245C540.828 27.2243 417.896 38.8956 450.095 41.2691C458.507 59.9943 473.591 105.831 466.629 139.378C459.212 175.118 443.578 190.168 424.574 197.753C483.899 198.059 627.331 201.092 456.337 201.092H417.179C416.819 203.519 397.742 205.584 414.415 201.092H203.523C133.849 201.092 129.5 228.683 63.5008 210.703C0.770191 193.613 -23.8724 115.516 30.0824 87.0326C84.0373 58.5492 34.561 63.4728 79.007 27.2243C153.209 -33.2922 340.595 27.2245 397.328 27.2245Z"-->
<!--                fill="#19335A"/>-->
<!--          </svg>-->
            <svg viewBox="9.75 14.659 762.559 216.461" width="762.559" height="216.461">
              <path d="M 406.679 41.555 C 550.179 41.555 733.873 53.659 766.072 56.033 C 774.484 74.758 773.977 115.831 767.015 149.378 C 759.598 185.118 763.453 199.735 744.449 207.32 C 803.774 207.626 636.682 215.423 465.688 215.423 L 426.53 215.423 C 423.748 215.422 428.39 215.425 423.766 215.423 L 212.874 215.423 C 143.2 215.423 138.851 243.014 72.852 225.034 C 10.121 207.944 -14.521 129.847 39.433 101.363 C 93.388 72.88 43.912 77.803 88.358 41.555 C 162.56 -18.962 349.946 41.555 406.679 41.555 Z" fill="#19335A"></path>
            </svg>
        </div>

      </div>

    </div>

    <div class="background d-none d-lg-block">
      <svg width="2924" height="1062" viewBox="0 0 2924 1062" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M 3.16 96.631 C -26.062 -272.356 228.737 -75.882 292.725 -95.327 C 378.042 -83.084 323.618 -65.943 498.371 -95.327 C 716.812 -132.058 714.606 -147.183 1025.72 -95.327 C 1336.83 -43.471 2885.524 -223.371 2901.958 19.787 C 2918.392 262.945 2947.193 660.476 2912.014 679.065 C 2861.231 705.899 1562.624 709.895 747.213 712.029 C 373.642 713.007 328.81 445.428 323.494 302.773 C 314.352 57.468 17.028 271.741 3.16 96.631 Z"
            fill="#19335A"/>
      </svg>
    </div>

  </section>

    <section class="section__solutions">
      <div class="solutions custom-container">
        <h2 class="solutions__title">Solutions</h2>
        <p class="solutions__subtitle">Aviapages API technologies will allow your business to work even more precisely and economy efficient.
          We have developed solutions which are dedicated for sales and commercial departments of operators, brokers, aggregators and other market players of the business aviation industry.
        </p>
      </div>

  </section>


  <section id="charter-box-widget"></section>

  <section class="section__about_api">
    <div class="about_api custom-container">
      <div class="row">
        <div class="about_api__left_column col-12 col-lg-5 ">
          <h2 class="about_api__title">About API</h2>
          <p class="about_api__subtitle">Aviapages API technologies will allow your business to work even more precisely and economy efficient.
            We have developed solutions which are dedicated for sales and commercial departments of operators,
            brokers, aggregators and other market players of the business aviation industry.
          </p>

          <div class="about_api__buttons">
            <a href="/about" class="btn outlined explore_api_btn">Learn More</a>
            <a href="/contacts" class="btn">Get Started For Free</a>
          </div>
        </div>
        <div class="col-12 col-lg-7 justify-content-center d-flex">
          <img class="about_api__image" src="../assets/images/landing_about_api_image.webp" height="447" width="667" alt="about api image">
        </div>

      </div>
    </div>
  </section>

  <section class="section__trusted">
    <div class="trusted custom-container">

      <div class="trusted__title">Trusted By Leading European Charter Companies</div>

      <div class=" trusted__companies">
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo"
               src="../assets/images/parters_logo/wheelsup.webp" alt="company logo" height="80" width="144">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo" src="../assets/images/parters_logo/nuvolops.webp" height="80" width="144"
               alt="company logo">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo" src="../assets/images/parters_logo/flying_group.webp" height="80" width="145"
               alt="company logo">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo" src="../assets/images/parters_logo/stack_aero.webp" height="80" width="145"
               alt="company logo">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo" src="../assets/images/parters_logo/gestair.webp" height="80" width="145"
               alt="company logo">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo"
               src="../assets/images/parters_logo/my_sky.webp" alt="company logo" height="80" width="145">
<!--        </div>-->
<!--        <div class="col trusted__companies__item">-->
          <img class="trusted__client_logo" src="../assets/images/parters_logo/unionaviation2.webp" height="80" width="145"
               alt="company logo">
<!--        </div>-->

        <img class="trusted__client_logo" src="../assets/images/parters_logo/fcg.webp" height="80" width="145"
               alt="company logo">

          <img class="trusted__client_logo" src="../assets/images/parters_logo/premiumjet.webp" height="80" width="145"
               alt="company logo">

          <img class="trusted__client_logo" src="../assets/images/parters_logo/elitavia.webp" height="80" width="145"
               alt="company logo">


          <img class="trusted__client_logo" src="../assets/images/parters_logo/klasjet2.webp" height="80" width="145"
               alt="company logo">

          <img class="trusted__client_logo" src="../assets/images/parters_logo/sparfell.webp" height="80" width="145"
               alt="company logo">
      </div>
    </div>
  </section>

  <section class="section__how_it_works">
    <div class="how_it_works custom-container">
      <h2 class="how_it_works__title">How It  Works</h2>


      <div class="row">
        <div class="col card">
          <div class="card__image">
            <img src="../assets/images/how_it_works/how_it_works_evaluate_icon.svg" width="102" height="100" alt="card icon">
          </div>
          <div class="card__title">Evaluate</div>
          <div class="card__description">
            Aviapages API technologies will allow your business to work even more precisely and economy efficient.
            We have developed solutions which are dedicated for sales and commercial departments of operators,
            brokers, aggregators and other market players of the business aviation industry.
          </div>
        </div>

        <div class="col card">
          <div class="card__image">
            <img src="../assets/images/how_it_works/how_it_works_integrate_icon.svg" width="115" height="100" alt="card icon">
          </div>
          <div class="card__title">Integrate</div>
          <div class="card__description">
            Streamline your workflow by encouraging all stakeholders from business to
            engineering to collaborate across the API design and development lifecycle.
          </div>
        </div>

        <div class="col card">
          <div class="card__image">
            <img src="../assets/images/how_it_works/how_it_works_use_icon.svg" width="104" height="104" alt="card icon">
          </div>
          <div class="card__title">Use</div>
          <div class="card__description">
            Design consistent APIs by automatically validating against predefined or custom style guidelines within the API designer.
          </div>
        </div>

      </div>
    </div>

  </section>

  <section class="section__integration">
    <div class="integration custom-container">
      <h3 class="integration__title">Ready to Integrate With Charter API?</h3>
      <div class="integration__buttons">
        <a href="/contacts" class="btn">Get Started For Free</a>
        <a href="/about" class="btn outlined explore_api_btn">Explore API</a>
      </div>
    </div>

  </section>


</template>

<script>
export default {
  name: "LandingView",
  mounted() {
      initCharterQuoteBoxFrame();
  }
}
</script>

<style scoped lang="scss">
.section__hero{
  overflow: hidden;
  @include media-breakpoint-down(lg) {
    padding-bottom: 7rem;
  }

  .hero{
    width: 50%;

    @include media-breakpoint-down(lg){
      width: 100%;
    }

    &__item {
      margin-top: 180px;
      margin-bottom: 220px;
      @include media-breakpoint-down(lg){
        margin-top: 60px;
        margin-bottom: 95px;
      }
    }
    &__title{
      font-weight: 600;
      font-size: 4.0625rem;
      line-height: 5.4375rem;
      margin-bottom: 0.625rem;
      @include media-breakpoint-down(lg){
        text-align: center;
        font-size: 3rem;
        line-height: 3.875rem;
      }

    }
    &__subtitle{
      font-size: 1.125rem;
      color: $main-color;
      line-height: 1.8125rem;
      font-weight: 400;
      @include media-breakpoint-down(lg){
        text-align: center;

      }
    }

    &__buttons{
      display: flex;
      gap: 1rem;
      margin-top: 1.5625rem;
      .btn{
        height: 45px;
        &.explore_api_btn{
          padding: 0 2rem;
        }
      }

      @include media-breakpoint-down(lg) {
        justify-content: center;
        flex-wrap: wrap;
      }
    }
  }

  .background{
    height: 100%;
    min-height: 1062px;
    position: absolute;
    top: 0;
    right: 0;
    //background-image: url(http://127.0.0.1:8080/img/main_view_mask.8da38468.svg);
    width: calc(50% + 260px);
    z-index: 0;
    background-repeat: no-repeat;
    background-position-x: right;
    overflow: hidden;
    svg{
      position: absolute;
      left: 0;
      &:after{
        position: absolute;
        content:"";
        height: 100%;
        width: 100%;
        left: 0;

      }

      & path {
        //animation: morph 11s infinite cubic-bezier(.11,-0.02,.46,.81);
        animation: morph 16s infinite linear;
      }

    }
  }
  .background_mobile{
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    width: calc(50% + 80px);
  }

  .map{
    position: relative;
    right: 0;
    z-index: 1;
    width: 50%;
     @include media-breakpoint-down(lg){
      width: 100%;
    }

    &__wrapper{
      position: relative;
      top: 50%;
      transform: translateY(-35%);
      z-index: 1;
      @include media-breakpoint-down(lg){
        top: 0;
        transform:none;
      }
    }
    &__background{
      background: radial-gradient(59.6% 57.58% at 35.86% 30.27%, #28509E 0%, #0D3C83 42.32%, #15337F 78.13%, #0D1F5C 100%), url("../assets/images/map.webp");
      border-radius: 50%;
      height: 400px;
      width: 400px;
      //margin: 0 auto;
      margin-left: auto;
      overflow: hidden;
      //box-shadow: inset 20px 0 80px 6px rgba(0, 0, 0, 1);
      //box-shadow: inset -12px -17px 91px #000D3C;

      @include media-breakpoint-down(lg){
        height: 180px;
        width: 180px;
        margin-right: auto;
      }
    }
    &__image{
      max-height: 100%;
      animation: rotate 4s linear infinite;
    }
    &__image__background{
      width: 100%;
      height: 100%;
      background-image: url("../assets/images/map_small.webp");
      background-size: auto 100%;
      background-position: 0 0;
      //background-size: cover;
      border-radius: 50%;
      animation: rotate_earth 320s linear infinite;
      box-shadow: inset -12px -17px 91px #000D3C, inset 20px 0 80px 6px rgba(0, 0, 0, 0.7);
      @include media-breakpoint-down(lg){
        box-shadow: inset -6px -6px 12px #000d3c, inset 7px 0px 17px 6px rgb(0 0 0 / 70%);
      }

    }

    .aircraft{
      position: absolute;
      top: 0;
      width: 400px;
      right: 0;
      bottom: 0;
      animation: rotate_aircraft 560s linear reverse infinite;

      @include media-breakpoint-down(lg){
        width: 180px;
        left: calc(50% - 90px);

      }

      &__image_1{
        position: absolute;
        top: -68px;
        left: 49px;
        width: 168px;
        @include media-breakpoint-down(lg){
          top: -42px;
          left: 19px;
          width: 95px;
        }
      }
      &__image_2{
        position: absolute;
        bottom: -60px;
        left: -100px;
        width: 262px;
        @include media-breakpoint-down(lg) {
          bottom: -37px;
          left: -34px;
          width: 124px;
        }
      }
      &__image_3{
        position: absolute;
        right: -174px;
        width: 370px;
        @include media-breakpoint-down(lg) {
          right: -75px;
          width: 180px;
        }
      }
    }

  }

  @keyframes rotate_earth {
    0% {
      background-position: 0 0 ;
    }
    100% {
      background-position: 734px 0;
    }
  }

  @keyframes rotate_aircraft {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);

    }
  }

  //@keyframes morph {
  //  0%,100% {
  //    d: path('M20.1601 96.6311C-9.06193 -272.356 245.737 -75.882 309.725 -95.327C395.042 -83.084 340.618 -65.9429 515.371 -95.327C733.812 -132.058 731.606 -147.183 1042.72 -95.327C1353.83 -43.471 2902.52 -223.371 2918.96 19.7871C2935.39 262.945 2964.19 660.476 2929.01 679.065C2878.23 705.899 1579.62 709.895 764.213 712.029C390.642 713.007 301.816 504.655 296.5 362C287.358 116.695 34.0281 271.741 20.1601 96.6311Z');
  //  }
  //  33% {
  //    d: path('M1.50158 75.9999C-27.7204 -292.987 245.738 -75.8819 309.726 -95.3269C395.043 -83.0839 340.619 -65.9429 515.372 -95.3269C733.813 -132.058 731.607 -147.183 1042.72 -95.3269C1353.83 -43.4709 2902.52 -223.371 2918.96 19.7872C2935.39 262.945 2908.18 240.411 2873 259C2822.22 285.834 1592.41 751.366 777.001 753.5C403.43 754.478 315.042 542.655 309.726 400C300.584 154.695 15.3696 251.11 1.50158 75.9999Z')
  //  }
  //  66% {
  //    d: path('M21.9998 41C-7.22217 -327.987 245.738 -75.882 309.726 -95.327C395.043 -83.084 340.619 -65.943 515.372 -95.327C733.813 -132.058 731.607 -147.183 1042.72 -95.327C1353.83 -43.471 2902.52 -223.371 2918.96 19.787C2935.39 262.945 2908.18 240.411 2873 259C2822.21 285.834 1640.41 797.366 824.999 799.5C451.428 800.478 315.042 610.655 309.726 468C298.565 168.5 35.8678 216.11 21.9998 41Z')
  //  }
  //}
  @keyframes morph {
    0%, 100% {
      d: path('M20.1601 96.6311C-9.06193 -272.356 245.737 -75.882 309.725 -95.327C395.042 -83.084 340.618 -65.9429 515.371 -95.327C733.812 -132.058 731.606 -147.183 1042.72 -95.327C1353.83 -43.471 2902.52 -223.371 2918.96 19.7871C2935.39 262.945 2964.19 660.476 2929.01 679.065C2878.23 705.899 1579.62 709.895 764.213 712.029C390.642 713.007 301.816 504.655 296.5 362C287.358 116.695 34.0281 271.741 20.1601 96.6311Z');
    }
    25% {
      d: path('M1.50158 75.9999C-27.7204 -292.987 245.738 -75.8819 309.726 -95.3269C395.043 -83.0839 340.619 -65.9429 515.372 -95.3269C733.813 -132.058 731.607 -147.183 1042.72 -95.3269C1353.83 -43.4709 2902.52 -223.371 2918.96 19.7872C2935.39 262.945 2908.18 240.411 2873 259C2822.22 285.834 1592.41 751.366 777.001 753.5C403.43 754.478 315.042 542.655 309.726 400C300.584 154.695 15.3696 251.11 1.50158 75.9999Z')
    }
    50% {
      d: path('M21.9998 41C-7.22217 -327.987 245.738 -75.882 309.726 -95.327C395.043 -83.084 340.619 -65.943 515.372 -95.327C733.813 -132.058 731.607 -147.183 1042.72 -95.327C1353.83 -43.471 2902.52 -223.371 2918.96 19.787C2935.39 262.945 2908.18 240.411 2873 259C2822.21 285.834 1640.41 797.366 824.999 799.5C451.428 800.478 315.042 610.655 309.726 468C298.565 168.5 35.8678 216.11 21.9998 41Z')
    }
    75% {
      d: path('M21.9998 41C-7.22217 -327.987 245.738 -75.882 309.726 -95.327C395.043 -83.084 340.619 -65.943 515.372 -95.327C733.813 -132.058 731.607 -147.183 1042.72 -95.327C1353.83 -43.471 2902.52 -223.371 2918.96 19.787C2935.39 262.945 2908.18 240.411 2873 259C2822.21 285.834 1668.41 775.366 853 777.5C479.429 778.478 327.316 609.155 322 466.5C310.839 167 35.8678 216.11 21.9998 41Z')
    }
  }

}

#charter-box-widget{
  margin-top: 80px;
  position: relative;
  z-index: 2;
}

.section__solutions {

  .solutions {
    max-width: 900px;

    &__title {
      text-align: center;
      font-weight: 600;
      margin-bottom: 1.75rem;
    }

    &__subtitle {
      text-align: center;
      font-size: 1.125rem;
      line-height: 1.8125rem;
    }
  }
}

.section__about_api{
  margin-top: 11.875rem;

  @include media-breakpoint-down(md) {
    margin-top: 5.625rem;
  }

  .about_api{

    &__left_column{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &__title{
      font-weight: 600;
      margin-bottom: 1.75rem;
      //margin-top: 2.5rem;
      @include media-breakpoint-down(lg){
        text-align: center;
      }

    }
    &__subtitle{
      font-size: 1.125rem;
      line-height: 1.8125rem;
      max-width: 25rem;
      margin-bottom: 0;
      @include media-breakpoint-down(lg){
        max-width: unset;
      }
    }
    &__buttons{
      margin-top: 2.5rem;
      display: flex;
      gap: 1rem;

      .btn{
        height: 2.8125rem;
      }
      @include media-breakpoint-down(lg){
        flex-wrap: wrap;
        justify-content: center;
        flex-direction: row-reverse;

      }
    }

    &__image{
      max-width: 100%;
      @include media-breakpoint-down(lg){
        margin-top: 2.5rem;
      }
    }
  }

}

.section__trusted{
  margin-top: 11.875rem;

  @include media-breakpoint-down(md) {
    margin-top: 7.5rem;
  }

  .trusted{
    &__title{
      color: $gray-1-color;
      font-weight: 600;
      text-align: center;
      font-size: 1.875rem;
      margin-bottom: 0.5rem;
      line-height: 1.2;
    }

    &__companies{
      max-width: 860px;
      margin: 0 auto;
      display: flex;
      margin-top: 1.25rem;
      justify-content: center;
      flex-wrap: wrap;
      &__item{
        margin-top: 2.25rem;
        display: flex;
        justify-content: center;
      }
    }

    &__client_logo {
      max-width: 145px;
      margin-top: 0.625rem;
    }

  }
}

.section__how_it_works{
  margin-top: 11.875rem;
  @include media-breakpoint-down(md){
    margin-top: 6.375rem;
  }

  .row{
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  .how_it_works{
    &__title{
      text-align: center;
      font-weight: 600;
      margin-bottom: 1.875rem;
    }

    .card{
      padding: 45px 30px 40px;
      box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.1);
      border-radius: 22px;
      margin: 0.625rem;
      min-width: 280px;

      &__image{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2.5rem;
      }

      &__title{
        font-size: 24px;
        color: $second-color;
        font-weight: 600;
        text-align: center;
        margin-bottom: 1.25rem;
      }
    }
  }
}

.section__integration{
  margin-top: 11.875rem;
  margin-bottom: 11.875rem;
  @include media-breakpoint-down(md){
    margin-top: 5.635rem;
    margin-bottom: 5.635rem;
  }
  .integration{

    &__title{
      font-weight: 600;
      text-align: center;
      font-size: 2.25rem;
    }

    &__buttons {
      margin-top: 2.1875rem;
      display: flex;
      gap: 1rem;
      justify-content: center;
      flex-wrap: wrap;

      .btn {
        height: 2.8125rem;
      }
    }
  }


}




</style>